import { ContentSection, EcosystemFeature } from "./types";
import MainOne from '../../../../assets/landing-1.png';
import MainTwo from '../../../../assets/landing-2.png';


export const transformativeSection: ContentSection = {
  title: "Empower Transformative Results",
  subtitle: "ClientVitals increases the number, volume, and quality of loans by reducing barriers to lending. Four principles underscore our success:",
  description: "<b>Empower knowledge.</b> We provide real-time, detailed credit information, right here, right now.<br /><br /><b>Empower action.</b> We transform this data into an insight-driven set of actions to take to transform pre-qualification credit.<br /><br /><b>Empowering expertise.</b> We offer bespoke and powerful counseling services to immediately impact pre-qualification credit.<br /><br /><b>Empower relationships.</b> We close the loop between lenders and now-qualified borrowers, so latent opportunities are never lost.",
  linkText: "Contact Us to Learn More",
  linkUrl: "#contact",
  imageSrc: MainOne,
  imageAlt: "Empowering financial transformation"
};


export const ecosystemData = {
  title: "A Powerful Ecosystem",
  subtitle: "ClientVitals unites sophisticated technology, and bespoke credit consulting to advance healthy credit and close the gaps between lenders and borrowers.",
  features: [
    {
      title: "The Dashboard",
      description: "A bespoke action plan, generating insights gleaned from credit reporting that provides specific and actionable recommendations for improving financial health"
    },
    {
      title: "Peerless credit counseling", 
      description: "Specialized industry experts provide bespoke services to transform credit health"
    },
    {
      title: "Closed Loop Referrals",
      description: "Seamless referral to our Trusted Partners to assist our consulting client achieve their financial goals"
    }
  ] as EcosystemFeature[],
  linkText: "Become a Partner, Start Referring",
  linkUrl: "/register-referral",
  imageSrc: MainTwo,
  imageAlt: "Powerful ecosystem visualization"
};


